import React, { useCallback, useState } from 'react';
import { Query } from '../_common';
import SearchBar from '../SearchBar';
import { SearchTypeEnum } from '../../types/SearchTypeEnum';
import { ModalForm, Option } from './interface';
import { useAuthContext } from '../Auth/AuthProvider';
import { useStoreContext } from '../App/StoreProvider';
import { PermissionEnum } from '../../types/PermissionEnum';
import { GET_ALL_CARRIERS, GET_ALL_STATES, GET_CARRIER_LIST_CSV } from '../../graphql/client/queries';
import { GetAllCarriers, GetAllStates, GetAllStates_getAllStates as StateType } from '../../types/schemaTypes';
import { Error, Loading } from '../_common';
import { useMutation, useQuery } from '@apollo/client/react';
import { SAVE_CARRIER, DELETE_CARRIER } from '../../graphql/client/mutations';
import './Carriers.scss';
import { GetAllCarriers_getAllCarriers as Carrier } from '../../types/schemaTypes';
import { Base64 } from 'js-base64';
import CarrierList from './CarriersList';
import { Alert } from 'react-bootstrap';

import { SaveCarrier } from '../../types/schemaTypes';
import AddCarrierModal from './AddEditCarrierModal/AddEditCarrierModal';
import { CarrierFilters } from '../Filter/CarrierFilters';
import {  ToastContainer, toast } from 'react-toastify';
import {toastOpt} from '../../utils/helpers/toastHelper'

const toasterOptions = { duration: 2500 };
const Messages = {
    delete: 'Carrier deleted successfully',
};
const ErrorMessages = {
    delete: 'Failed to delete Carrier',
};

let selectedCarrier: Carrier | undefined;

const PAGE_SIZE = 50;

const Carriers = (): React.ReactElement => {
    const [errorMessage, setErrorMessage] = useState('');
    const [showAddCarrierModal, setShowAddCarrierModal] = useState(false);
    const [modalForm, setModalForm] = useState(ModalForm.EMPTY);
    const [isEndOfResults, setIsEndOfResults] = useState(false);
    const [tabTitle, setTabTitle] = useState(document.title);
    const [listHeight, setListHeight] = useState(window.screen.height);
    const [csvCalled, setCsvCalled] = useState(false);
    const abortController = new AbortController();
    document.title = 'SBS';
    const [state] = useStoreContext();

    const canEditCarrier = useAuthContext().userHasPermission(PermissionEnum.EditDriverCompany);
    const canAddEditLogisticsPartner = useAuthContext().userHasPermission(PermissionEnum.EditLogisticsPartner);

    const {
        carrierList: { searchPhrase, compliantStatus },
    } = state;

    const variables = {
        input: { searchString: searchPhrase, compliantStatus },
    };
    const onCompletedCarrier = (data: SaveCarrier): void => {
        if (data.saveCarrier === null) return;
        const saveCarrierErrors = data.saveCarrier.errors;
        if (saveCarrierErrors && saveCarrierErrors.length > 0) {
            setErrorMessage(saveCarrierErrors[0] || '');
        } else {
            selectedCarrier = undefined;
            setErrorMessage('');
            setShowAddCarrierModal(false);
        }
    };
    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };

        Comp.displayName = 'toast';
        return Comp;
    };
    const onCompleted = action => {
      
        toast.success(Messages[action],toastOpt);
        //refetch();
    };
    const onActionError = action => {
      
        toast.error(ErrorMessages[action],toastOpt);
        //refetch();
    };
    const [saveCarrier] = useMutation<SaveCarrier>(SAVE_CARRIER, {
        onCompleted: onCompletedCarrier,
        refetchQueries: () => {
            return [
                {
                    query: GET_ALL_CARRIERS,
                    variables,
                },
            ];
        },
    });

    const [deleteCarrier] = useMutation(DELETE_CARRIER, {
        onCompleted: () => onCompleted('delete'),
        onError: () => onActionError('delete'),
        refetchQueries: () => {
            return [
                {
                    query: GET_ALL_CARRIERS,
                    variables,
                },
            ];
        },
    });

    const downloadCsv = (csvExport): Blob => {
        const result = csvExport.getCarrierListCSV.csv;
        const decodedCsv = Base64.decode(result);
        const file = new Blob([decodedCsv], { type: 'application/csv' });
        return file;
    };

    const getCurrentDate = (): string => {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const strDay = day < 10 ? `0${day}` : `${day}`;
        const strMonth = month < 10 ? `0${month}` : `${month}`;
        return `${year}${strMonth}${strDay}`;
    };

    const { loading: csvLoading, data: csvExport } = useQuery(GET_CARRIER_LIST_CSV, {
        variables,
        skip: !csvCalled,
        fetchPolicy: 'no-cache',
    });

    React.useEffect(() => {
        if (!csvLoading && csvCalled && csvExport) {
            const file: Blob = downloadCsv(csvExport);
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.download = `List of Carriers_${getCurrentDate()}.csv`;
            a.click();
            setCsvCalled(false);
        }
    }, [csvLoading, csvCalled, csvExport]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDelete = useCallback(async (record: any) => {
        const variables = { input: { id: record.id } };
        await deleteCarrier({ variables });
    }, []);

    const handleOnHide = (): void => {
        selectedCarrier = undefined;
        setErrorMessage('');
        setShowAddCarrierModal(false);
    };
    const handleOnSave = async (
        id: number,
        companyName: string,
        name: string,
        stateId: number,
        city: string,
        email: string,
        addressLine1: string,
        addressLine2: string,
        phoneNumber: string,
        type: string,
        zip: string,
        activeInactiveDate: string,
        activeInactiveUser: string,
        extSystemIdentifier: string,
        extSystemName: string,
        isActive: boolean,
        notes: string,
        extSystemIdentifier2: string,
        acronym: string,
    ): Promise<void> => {
        // if (selectedCarrier) {
        //     //selectedCarrier.id = id;
        //     selectedCarrier.city = city;
        //     selectedCarrier.companyName = companyName;
        //     selectedCarrier.email = email;
        //     selectedCarrier.extSystemIdentifier = extSystemIdentifier;
        //     selectedCarrier.stateId = stateId;
        //     selectedCarrier.extSystemName = extSystemName;
        //     selectedCarrier.isActive = isActive;
        //     selectedCarrier.name = name;
        //     selectedCarrier.notes = notes;
        //     selectedCarrier.phoneNumber = phoneNumber;
        //     selectedCarrier.type = type;
        //     selectedCarrier.zip = zip;
        //     selectedCarrier.activeInactiveDate = activeInactiveDate;
        //     selectedCarrier.activeInactiveUser = activeInactiveUser;
        //     selectedCarrier.addressLine1 = addressLine1;
        //     selectedCarrier.addressLine2 = addressLine2;
        //     selectedCarrier.extSystemIdentifier2 = extSystemIdentifier2;
        // }

        const variables = {
            input: {
                id,
                companyName,
                type,
                stateId,
                extSystemIdentifier,
                extSystemName,
                name,
                addressLine1,
                addressLine2,
                city,
                zip,
                phoneNumber,
                email,
                isActive,
                extSystemIdentifier2,
                acronym,
            },
        };
        await saveCarrier({ variables });
        // selectedCarrier = undefined;
        // setErrorMessage('');
        // setShowAddCarrierModal(false);
    };
    const { data: statesData } = useQuery<GetAllStates>(GET_ALL_STATES);
    const options: Option[] = [];
    if (statesData && statesData.getAllStates) {
        statesData.getAllStates.forEach((element: StateType | null) => {
            if (!element || element.stateName === null || element.id === null) return;
            options.push({
                id: element.id,
                name: element.stateName,
            });
        });
    }

    const abortRequest = (): void => {
        abortController.abort();
    };

    const setListContainerHeight = (): void => {
        const filterDiv = document.getElementById('loadsFilterContainer');
        const listDiv = document.getElementById('loadsListContainer');

        let filterHeight = 0;
        // setTimeout in place to avoid animation miscalculations
        setTimeout(() => {
            if (filterDiv) {
                filterHeight = filterDiv.scrollHeight;
            }
            if (listDiv) {
                setListHeight(Math.min(filterHeight));
            }
        }, 100);
    };

    document.title = 'Carriers';
    return (
        <Query<GetAllCarriers> query={GET_ALL_CARRIERS} variables={variables}>
            {({
                error,
                data,
                loading,
                refetch,
                fetchMore,
            }): React.ReactElement | null => {
                if (error) {
                    return <Error error={error} />;
                }

                const carriers: Carrier[] = [];

                if (data && data.getAllCarriers && data.getAllCarriers.length !== 0) {
                    data.getAllCarriers.forEach((element) => {
                        if (element !== null) {
                            carriers.push(element as Carrier);
                        }
                    });
                }

                const offset = data && data.getAllCarriers ? data.getAllCarriers.length / PAGE_SIZE : 0;
                React.useEffect(() => {
                    if (
                        offset % 1 !== 0 ||
                        (!isEndOfResults && data && data.getAllCarriers && data.getAllCarriers.length < PAGE_SIZE)
                    ) {
                        setIsEndOfResults(true);
                    }
                }, [offset]);
                if (loading) {
                    return <Loading />;
                }

                return (
                    <div className="Carriers-Container">
                        
                        <div className="Carriers-Top-Container">
                            <SearchBar type={SearchTypeEnum.Carrier}></SearchBar>
                            <div className="Carriers-RightOptions">
                                {(canEditCarrier || canAddEditLogisticsPartner) && (
                                    <div
                                        className="Carriers-Create-New-Carrier Row"
                                        onClick={() => {
                                            setShowAddCarrierModal(true);
                                            setModalForm(ModalForm.ADD_CARRIER);
                                        }}
                                    >
                                        <i className="material-icons Carriers-Icon">add_circle</i>
                                        <span className="Carriers-Link">Create New Carrier</span>
                                    </div>
                                )}
                            </div>
                            {!showAddCarrierModal && <div className="Carriers-Erors">{errorMessage}</div>}
                        </div>
                        <div className="JobLoadsManagement-BodyContainer">
                            <div id="loadsFilterContainer" className="Drivers-FiltersContainer">
                                <CarrierFilters
                                    abortRequest={abortRequest}
                                    onFilterToggle={setListContainerHeight}
                                    csvLoading={loading}
                                    showExportButton={carriers.length > 0}
                                    exportCsv={() => {
                                        setCsvCalled(true);
                                    }}
                                />
                            </div>
                            <div
                                id="loadsListContainer"
                                style={{ height: listHeight, width: '100%', overflow: 'auto' }}
                            >
                                <div className="CarriersItem-Bottom-Container">
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-2">
                                        <div className="Carriers-Header-Title">Company Name</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                                        <div className="Carriers-Header-Title">Type</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                                        <div className="Carriers-Header-Title">IsActive</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-2">
                                        <div className="Carriers-Header-Title">Active/Inactive Date</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-2">
                                        <div className="Carriers-Header-Title">Active/Inactive User</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                                        <div className="Carriers-Header-Title">JDENumber</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                                        <div className="Carriers-Header-Title">ISNET ID</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                                        <div className="Carriers-Header-Title">IsCompliant</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                                        <div className="Carriers-Header-Title">Action</div>
                                    </div>
                                </div>
                                
                                <CarrierList
                                    carriers={carriers}
                                    refetch={refetch}
                                    options={options}
                                    isLoading={loading}
                                    canEditCarriers={canEditCarrier}
                                    canAddEditLogisticsPartner={canAddEditLogisticsPartner}
                                    onEditClick={Carrier => {
                                        setShowAddCarrierModal(true);
                                        setModalForm(ModalForm.EDIT_CARRIER);
                                        selectedCarrier = Carrier;
                                    }}
                                    onDelete={onDelete}
                                    isEndOfResults={isEndOfResults}
                                    onLoadMore={() =>
                                        fetchMore({
                                            variables: {
                                                offset,
                                            },
                                            updateQuery: (prev, { fetchMoreResult }) => {
                                                if (
                                                    prev &&
                                                    fetchMoreResult &&
                                                    prev.getAllCarriers &&
                                                    fetchMoreResult.getAllCarriers
                                                ) {
                                                    return Object.assign({}, prev, {
                                                        getAllCarriers: [
                                                            ...prev.getAllCarriers,
                                                            ...fetchMoreResult.getAllCarriers,
                                                        ],
                                                    });
                                                } else {
                                                    return prev;
                                                }
                                            },
                                        })
                                    }
                                />
                            </div>
                            <ToastContainer />
                        </div>
                        <AddCarrierModal
                            show={showAddCarrierModal}
                            modalForm={modalForm}
                            options={options}
                            selectedCarrier={selectedCarrier}
                            onClickHide={handleOnHide}
                            onClickSave={handleOnSave}
                            errorMessage={errorMessage}
                        ></AddCarrierModal>
                    </div>
                );
            }}
        </Query>
    );
};

export default Carriers;
